export type ShippingLabelProps = {
    companyName?: string | null;
    recipient?: string | null;
    addressLine1?: string | null;
    addressLine2?: string | null;
    postCode?: string | null;
    city?: string | null;
    countryLabel?: string | null;
    /** Renders the dashed "label" frame around the address (used in the card ordering preview). */
    bordered?: boolean;
};

const ShippingLabel = ({
    companyName,
    recipient,
    addressLine1,
    addressLine2,
    postCode,
    city,
    countryLabel,
    bordered = false,
}: ShippingLabelProps) => {
    const emphasisClassName = bordered ? 'text-medium' : undefined;

    return (
        <div
            className={
                bordered
                    ? 'border border-color-primary border-style-dashed rounded flex-1-1-0 align-self-start padding-15 min-width-50pct max-width-100pct'
                    : 'display-flex flex-column gap-2 flex-1-1-0'
            }
        >
            {companyName && <div className={emphasisClassName}>{companyName}</div>}
            {recipient && <div className={emphasisClassName}>{recipient}</div>}
            {addressLine1 && <div>{addressLine1}</div>}
            {addressLine2 && <div>{addressLine2}</div>}
            {(postCode || city) && (
                <div>
                    {postCode} {city}
                </div>
            )}
            {countryLabel && <div>{countryLabel}</div>}
        </div>
    );
};

export default ShippingLabel;
